import React from 'react';
import { traydContent } from '../rich-content/trayd-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const TraydDetailPage = () => {
  return <AutomaticPageBuilder content={traydContent} />;
};

export default TraydDetailPage;
